'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _viewprt = require('viewprt');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InViewport = function InViewport(elements) {
  (0, _classCallCheck3.default)(this, InViewport);

  elements.forEach(function (el) {
    (0, _viewprt.ElementObserver)(el, {
      onEnter: function onEnter(el) {
        el.classList.add('js-InViewport-visible');
      },

      once: true,
      offset: 150
    });
  });
};

exports.default = InViewport;